/* A simple KVP section of the store (state.rdx) */

let nextId = 0;

export default class Rdx {

  static store;

  static Keys = {
    SIDEBAR_ACTIVE_KEY: "SIDEBAR_ACTIVE_KEY",
    SIDEBAR_PANELS_EXPANDED: "SIDEBAR_PANELS_EXPANDED",
    INFOPANEL_ACTIVE_KEY: "INFOPANEL_ACTIVE_KEY",
    INFOPANEL_OPEN: "INFOPANEL_OPEN",
    EVENTS_DATEFILTER_OPTION: "EVENTS_DATEFILTER_OPTION",
    EVENTS_DATEFILTER_DATESELECTED: "EVENTS_DATEFILTER_DATESELECTED",
    EVENTS_TIMEFILTER_OPTION: "EVENTS_TIMEFILTER_OPTION",
    EVENTS_TYPEFILTER_OPTION: "EVENTS_TYPEFILTER_OPTION",
    EVENTS_TYPEFILTER_OPTIONS: "EVENTS_TYPEFILTER_OPTIONS",

    ACTIVE_HOTDESK_AREA_ID: "ACTIVE_HOTDESK_AREA_ID",
    ACTIVE_HOTEL_AREA_ID: "ACTIVE_HOTEL_AREA_ID"
  };

  static Types = {
    RESET_ALL: "RESET_ALL",
    SET_VALUE: "SET_VALUE"
  };

  static Actions = {

    resetAll: (key,value) => ({
      type: Rdx.Types.RESET_ALL
    }),

    setValue: (key,value) => ({
      type: Rdx.Types.SET_VALUE,
      payload: {key: key, value: value}
    })

  };

  static Selectors = {

    getValue: (state,section,key) => {
      if (state[section]) return state[section][key];
    }

  }

  static Reducers = {

    rdx: (state = {}, action) => {
      let newState;
      switch (action.type) {
        case Rdx.Types.RESET_ALL:
          newState = Object.assign({}, Rdx.getInitialState().rdx);
          Object.keys(state).forEach(k => {
            if (k && k.indexOf("cfg-") === 0) {
              newState[k] = state[k];
            }
          });
          return newState;
        case Rdx.Types.SET_VALUE:
          newState = Object.assign({}, state);
          newState[action.payload.key] = action.payload.value;
          return newState;
        default:
          return state
      }
    }

  }

  static getInitialState() {
    const initialState = {
      rdx: {}
    };
    initialState.rdx[Rdx.Keys.EVENTS_DATEFILTER_OPTION] = "today";
    return initialState;
  }

  static getNextComponentId() {
    return "component_" + nextId++;
  }

  static getNextId() {
    return nextId++;
  }

  static getValue(state,key) {
    if (!state && Rdx.store) {
      state = Rdx.store.getState();
    }
    return Rdx.Selectors.getValue(state,"rdx",key);
  }

  static resetAll(store) {
    const action = Rdx.Actions.resetAll();
    if (!store) store = Rdx.store;
    store.dispatch(action);
  }

  static setValue(component,key,value) {
    const action = Rdx.Actions.setValue(key,value);
    if (!component && Rdx.store) {
      const dispatch = Rdx.store.dispatch;
      dispatch(action);
    } else {
      const dispatch = component.props.dispatch;
      dispatch(action);
    }
  }

}
